import request from '@/plugins/request';

/**
 * 获取合作伙伴列表
 * @param {Object} params - 请求参数
 * @param {string} params.category - 分类（使用dictValue）
 * @returns {Promise} - 返回Promise对象
 */
export function getFriendsList(params) {
  return request({
    url: '/fronted/friends/getList',
    method: 'get',
    params
  });
}

/**
 * 根据分类获取合作伙伴
 * @param {string} category - 分类值（dictValue）
 * @returns {Promise} - 返回Promise对象
 */
export function getFriendsByCategory(category) {
  return request({
    url: '/fronted/friends/getList',
    method: 'get',
    params: { category }
  });
}
